import { addMonths, format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export const formatDate = (date, timeZone, dateFormat) => {
    if (date) {
      const zonedDate = utcToZonedTime(date, timeZone)
      return format(new Date(zonedDate), dateFormat);
    } else {
      return '--';
    }
}
